"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
require("./style.css");
var _login = require("../../../../../consts/login");
var _consts = require("../../../../../consts");
var _QrCode = _interopRequireDefault(require("../../../../QrCode"));
var _login2 = require("../../../../../servers/login");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var Index = function Index(props) {
  var setIsRealName = props.setIsRealName,
    curItem = props.curItem,
    onError = props.onError,
    bizType = props.bizType,
    useType = props.useType;
  // 是否错误
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isError = _useState2[0],
    setIsError = _useState2[1];
  var qrRef = (0, _react.useRef)(null);
  /**
   * 二维码状态回调
   * @param qrState
   */
  var setQrCodeStatus = function setQrCodeStatus(qrState) {
    if (qrState === _login.QRCODE_STATUS.scanned) {
      var guild = qrRef.current.qrCode.split('?t=NL')[0].split('gyc://gyyx.cn/')[1];
      (0, _login2.qrLogin)({
        guild: guild,
        isHaiWai: useType !== _login.DEFAULT_USE_TYPE
      }).then(function (res) {
        var isRealName = false;
        var isError = false;
        if (!res.success) {
          if (res.data === _login.QRCODE_STATUS.realNameError) {
            isRealName = true;
          } else {
            isError = true;
          }
          setIsRealName(isRealName); // 需要实名
          setIsError(isError);
          onError && onError(res);
          return;
        }
        props.onOk && props.onOk({
          type: 'qrcode'
        });
      });
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "gy_qrCode_wrap"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "gy_qrCode_title"
  }, "\u4F7F\u7528", /*#__PURE__*/_react.default.createElement("a", {
    className: "gy_qrCode_btn",
    type: "link",
    href: _consts.GYYX_APP_URL,
    target: "_blank"
  }, "\u5149\u5B87\u6E38\u620FAPP"), "\u626B\u63CF\u4E8C\u7EF4\u7801\u5B89\u5168\u767B\u5F55"), isError && /*#__PURE__*/_react.default.createElement("p", {
    className: "gy_qrCode_tip"
  }, "\u8D26\u53F7\u5F02\u5E38"), /*#__PURE__*/_react.default.createElement("div", {
    className: "gy_qrCode_content"
  }, curItem === 'qrcode' && /*#__PURE__*/_react.default.createElement(_QrCode.default, {
    ref: qrRef,
    setQrCodeStatus: setQrCodeStatus,
    bizType: bizType
  })));
};
var _default = Index;
exports.default = _default;